export default __webpack_public_path__ + "static/media/Snd_T_Starts.6cd3b6c4.mp3";